// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components
import DefaultLayout from "../../layout/standard/primary/DefaultLayout";

// Sub-Components
import Hero from "./com/hero/Hero";
import About from "./com/about/About";
import Experience from "./com/experience/Experience";
import Tech from "./com/tech/Tech";
import Projects from "./com/projects/Projects";

// Data / Images / Icons

function Home() {
  return (
    <DefaultLayout>
      <Hero />
      <About />
      <Experience />
      <Tech />
      <Projects />
    </DefaultLayout>
  );
}

export default Home;
